
import { defineComponent, getCurrentInstance } from 'vue';
import { immediateSendLog } from '@/common/radar';
// import cookies from 'js-cookie';
// import { getTargetUrlFromWebOrDesktop, getQuery } from '@/common/util';

export default defineComponent({
    props: {
        page: {
            type: String,
            default: 'message',
        },
        desc: {
            type: String,
            default: '',
        },
    },
    setup(props, ctx) {
        const { proxy } = getCurrentInstance() as { proxy: any };

        const handleConfirm = () => {
            immediateSendLog({
                type: 'click',
                name: 'SWITCH_BUTTON',
            });
            proxy.$bus.emit('launchApp');
        };

        return {
            handleConfirm,
        };
    },
});
